import dynamic from 'next/dynamic';
import { useContext } from 'react';

import {
  IconCommentedPosts,
  IconHeartSideBar,
  IconHomeFeed,
  IconMyPosts,
} from '@/components/assets';
import { useAuth } from '@/provider/UserProvider';

import FeedContext from '../FeedContext';

export const FEED_FILTER_TYPE = {
  all: 'creator',
  my: 'my',
  creation: 'creator',
  like: 'react',
  comment: 'comment',
  follow: 'follow',
};

const ListTab = [
  { title: 'Feed', value: FEED_FILTER_TYPE.all, icon: IconHomeFeed },
  { title: 'My Posts', value: FEED_FILTER_TYPE.my, icon: IconMyPosts },
  { title: 'Liked Posts', value: FEED_FILTER_TYPE.like, icon: IconHeartSideBar },
  { title: 'Commented Posts', value: FEED_FILTER_TYPE.comment, icon: IconCommentedPosts },
];

const DynamicInfoProfileFeed = dynamic(() => import('./InfoProfileFeed'), { ssr: false });

const SideBar: React.FC<any> = () => {
  const { data, contextActionGenerator } = useContext(FeedContext);
  const { isLogin } = useAuth();
  return (
    <nav className="w-[calc(100%/5)] lg:w-1/3 sm:!w-full">
      <div className="sticky top-24 inline-flex w-full flex-col items-start gap-6">
        {isLogin && <DynamicInfoProfileFeed />}

        <div className="flex w-5/6 flex-col items-start gap-1">
          {ListTab.map((tab) => {
            const Icon = tab.icon;
            const isFocus = data.filter === tab.value;
            return (
              <div
                className={`flex w-fit items-center gap-2 rounded-[100px] py-3 pl-4 pr-5 hover:cursor-pointer hover:bg-gray-100 ${
                  isFocus ? 'bg-orange-500' : ''
                }`}
                key={tab.value}
                onClick={() => contextActionGenerator.setFilterStatusWithLoggedIn(tab.value)}
              >
                <Icon color={isFocus ? '#fff' : '#616879'} />
                <p className={`text-16 font-semibold ${isFocus ? 'text-white' : 'text-black'}`}>
                  {tab.title}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default SideBar;
